import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';


// The MuiTheme allows me to define the primary and secondary colors.
const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
      primary: {
          main: '#2980B7', /* this is the blue */
      },
      secondary: {
          main: '#7F8C8D'  /* this is the greyshade4 */
          // light:
          // dark:
      }
  }
});

const styles = theme => ({
  root: {
    marginRight: 40,
  },
  iconHover: {
    margin: theme.spacing.unit * 2,
    '&:hover': {
      color: '#2471a2',   /* darker color blue */
    },
  },
});

function PlusIcon(props) {
  const { classes } = props;

  // function onClick() {
  //   props.onClickHandler();
  // }

  return (
    <MuiThemeProvider theme={theme}>
    <div className={classes.root}>
      <Icon className={classes.iconHover} color="primary" style={{ fontSize: 45 }} >
        add_circle
      </Icon>
    </div>
    </MuiThemeProvider>
  );
}

export default withStyles(styles)(PlusIcon);



// WEBPACK FOOTER //
// ./src/components/icons/PlusIcon.js